import script from "./companyPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./companyPreview.vue?vue&type=script&setup=true&lang=js"

import "./companyPreview.vue?vue&type=style&index=0&id=47023fc3&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/zh-operate-subapp_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47023fc3"]])

export default __exports__